import {Model, Collection} from 'vue-mc'

export default class Sales extends Collection {
  async summary(params) {
    let request = await this.createRequest({
      method: 'GET',
      url: `/api/v2/orders/summary`,
      params:params
    }).send()

    if(request.response.data.orders) {
      return request.response.data.orders
    }
    return {total_orders:0 , total_amount:0, total_events:0}
  }
}
